import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { RewriteSequenceInstanceInput } from 'crono-fe-common/types/DTO/rewriteSequenceInstanceInput';
import {
  CUSTOMER_SCORE_EVENTS,
  useCustomerScore,
} from 'context/analytics/useCustomerScore';

export default function useRewriteSequenceInstance() {
  const queryClient = useQueryClient();
  const customerScore = useCustomerScore();

  const rewriteMessage = (rewriteInput: RewriteSequenceInstanceInput) => {
    const request: Request = {
      url: `${ENDPOINTS.assistant.rewriteSequenceInstance}`,
      config: {
        method: 'post',
        data: { data: rewriteInput },
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<null>,
    CronoError,
    RewriteSequenceInstanceInput
  >(rewriteMessage, {
    onSuccess: () => {
      customerScore?.track(CUSTOMER_SCORE_EVENTS.REWRITE);

      queryClient.invalidateQueries([ENDPOINTS.strategy.prospect]);
      queryClient.invalidateQueries([ENDPOINTS.strategy.search]);
      queryClient.invalidateQueries([ENDPOINTS.strategy.main]);
      queryClient.invalidateQueries([ENDPOINTS.strategy.details]);
      queryClient.invalidateQueries([ENDPOINTS.prospect.search.strategy]);
    },
  });

  return { data, mutate, ...rest };
}
